import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import ErrorBoundary from '@/components/ErrorBoundary';
import ProtectedRoute from '@/components/ProtectedRoute';
import PermissionGuard from '@/components/PermissionGuard';
import Login from '@/pages/Login';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import DataDeletion from '@/pages/DataDeletion';
import CatalogPublic from '@/pages/CatalogPublic';
import TiendaPublica from '@/pages/TiendaPublica';
import LandingPasamanos from '@/pages/LandingPasamanos';
import LandingEuro from '@/pages/LandingEuro';
import LandingFachadas from '@/pages/LandingFachadas';
import LandingDuchas from '@/pages/LandingDuchas';
import LandingTecho from '@/pages/LandingTecho';
import LandingPVC from '@/pages/LandingPVC';
import LandingAcero from '@/pages/LandingAcero';
import CatalogoSoluciones from '@/pages/CatalogoSoluciones';
import LeadsLanding from '@/pages/LeadsLanding';
import LandingPagesHub from '@/pages/LandingPagesHub';
import TiendaAdmin from '@/pages/TiendaAdmin';
import DesignPreview from '@/pages/DesignPreview';
import Dashboard from '@/pages/Dashboard';
import Inbox from '@/pages/Inbox';
import Customers from '@/pages/Customers';
import Orders from '@/pages/Orders';
import Templates from '@/pages/Templates';
import Settings from '@/pages/Settings';
import Admin from '@/pages/Admin';
import Reports from '@/pages/Reports';
import Ranking from '@/pages/Ranking';
import Vendors from '@/pages/Vendors';
import Cotizador from '@/pages/Cotizador';
import PresupuestosSA from '@/pages/PresupuestosSA';
import PizarraSach from '@/pages/PizarraSach';
import Coverage from '@/pages/Coverage';
import MyProfile from '@/pages/MyProfile';
import Catalog from '@/pages/Catalog';
import MiDia from '@/pages/MiDia';
import Pendientes from '@/pages/Pendientes';
import Chat from '@/pages/Chat';
import StockSearch from '@/pages/StockSearch';
import AsistenteIA from '@/pages/AsistenteIA';
import ChatIA from '@/pages/ChatIA';
import HarpERP from '@/pages/HarpERP';
import Alertas from '@/pages/Alertas';
import DashboardGerencial from '@/pages/DashboardGerencial';
import DashboardComercial from '@/pages/DashboardComercial';
import WaCampaigns from '@/pages/WaCampaigns';
import Produccion from '@/pages/Produccion';
import Programacion from '@/pages/Programacion';
import BibliotecaSimbolos from '@/pages/BibliotecaSimbolos';
import Instaladores from '@/pages/Instaladores';
import PlanTrabajo from '@/pages/PlanTrabajo';
import Prospectos from '@/pages/Prospectos';
import AiCostos from '@/pages/AiCostos';
import Reportes from '@/pages/Reportes';
import ReporteActividades from '@/pages/ReporteActividades';
import ClientesVendedores from '@/pages/ClientesVendedores';
import Clientes from '@/pages/Clientes';
import ClientesRedes from '@/pages/ClientesRedes';
import Compartir from '@/pages/Compartir';
import Layout from '@/components/Layout';

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <ThemeProvider>
          <BrowserRouter>
            <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/data-deletion" element={<DataDeletion />} />
            <Route path="/catalogo/:businessId" element={<CatalogPublic />} />
            <Route path="/tienda/:empresa" element={<TiendaPublica />} />
            <Route path="/pasamanosaceroinox" element={<LandingPasamanos />} />
            <Route path="/ventanasypuertaseuro" element={<LandingEuro />} />
            <Route path="/fachadasvidriotemplado" element={<LandingFachadas />} />
            <Route path="/duchasymamparas" element={<LandingDuchas />} />
            <Route path="/techocurvo" element={<LandingTecho />} />
            <Route path="/pvcpuertasyventanas" element={<LandingPVC />} />
            <Route path="/aceroinox" element={<LandingAcero />} />
            <Route path="/pasamanos" element={<LandingPasamanos />} />
            <Route path="/euro" element={<LandingEuro />} />
            <Route path="/fachadas" element={<LandingFachadas />} />
            <Route path="/duchas" element={<LandingDuchas />} />
            <Route path="/techo" element={<LandingTecho />} />
            <Route path="/pvc" element={<LandingPVC />} />
            <Route path="/soluciones" element={<CatalogoSoluciones />} />
            <Route path="/design-preview" element={<DesignPreview />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/mi-dia" replace />} />
              <Route path="dashboard" element={<PermissionGuard module="dashboard"><Dashboard /></PermissionGuard>} />
              <Route path="mi-dia" element={<MiDia />} />
              <Route path="pendientes" element={<Pendientes />} />
              <Route path="chat" element={<Chat />} />
              <Route path="compartir" element={<Compartir />} />
              <Route path="stock" element={<StockSearch />} />
              <Route path="asistente-ia" element={<AsistenteIA />} />
              <Route path="chat-ia" element={<ChatIA />} />
              <Route path="harperp" element={<PermissionGuard module="harperp"><HarpERP /></PermissionGuard>} />
              <Route path="alertas" element={<PermissionGuard module="alertas"><Alertas /></PermissionGuard>} />
              <Route path="dashboard-gerencial" element={<PermissionGuard module="dashboard_gerencial"><DashboardGerencial /></PermissionGuard>} />
              <Route path="dashboard-comercial" element={<PermissionGuard module="dashboard_comercial"><DashboardComercial /></PermissionGuard>} />
              <Route path="campañas" element={<PermissionGuard module="wa_campaigns"><WaCampaigns /></PermissionGuard>} />
              <Route path="campanas" element={<PermissionGuard module="wa_campaigns"><WaCampaigns /></PermissionGuard>} />
              <Route path="produccion" element={<PermissionGuard module="produccion"><Produccion /></PermissionGuard>} />
              <Route path="programacion" element={<PermissionGuard module="programacion"><Programacion /></PermissionGuard>} />
              <Route path="instaladores" element={<PermissionGuard module="instaladores"><Instaladores /></PermissionGuard>} />
              <Route path="plan-trabajo" element={<PermissionGuard module="plan_trabajo"><PlanTrabajo /></PermissionGuard>} />
              <Route path="prospectos" element={<PermissionGuard module="prospectos"><Prospectos /></PermissionGuard>} />
              <Route path="leads-landing" element={<PermissionGuard module="leads_landing"><LeadsLanding /></PermissionGuard>} />
              <Route path="landing-pages" element={<PermissionGuard module="landing_pages"><LandingPagesHub /></PermissionGuard>} />
              <Route path="ai-costos" element={<PermissionGuard module="ai_costos"><AiCostos /></PermissionGuard>} />
              <Route path="reportes" element={<PermissionGuard module="reportes"><Reportes /></PermissionGuard>} />
              <Route path="reporte-actividades" element={<PermissionGuard module="reportes"><ReporteActividades /></PermissionGuard>} />
              <Route path="clientes" element={<PermissionGuard module="clientes"><Clientes /></PermissionGuard>} />
              <Route path="clientes-vendedores" element={<PermissionGuard module="clientes_vendedores"><ClientesVendedores /></PermissionGuard>} />
              <Route path="clientes-redes" element={<PermissionGuard module="clientes_redes"><ClientesRedes /></PermissionGuard>} />
              <Route path="inbox" element={<PermissionGuard module="inbox"><Inbox /></PermissionGuard>} />
              <Route path="customers" element={<PermissionGuard module="customers"><Customers /></PermissionGuard>} />
              <Route path="orders" element={<PermissionGuard module="orders"><Orders /></PermissionGuard>} />
              <Route path="catalog" element={<PermissionGuard module="catalogo"><Catalog /></PermissionGuard>} />
              <Route path="tienda-admin" element={<PermissionGuard module="tienda_admin"><TiendaAdmin /></PermissionGuard>} />
              <Route path="templates" element={<PermissionGuard module="templates"><Templates /></PermissionGuard>} />
              <Route path="reports" element={<PermissionGuard module="reports"><Reports /></PermissionGuard>} />
              <Route path="ranking" element={<PermissionGuard module="ranking"><Ranking /></PermissionGuard>} />
              <Route path="vendors" element={<PermissionGuard module="vendors"><Vendors /></PermissionGuard>} />
              <Route path="coverage" element={<PermissionGuard module="coverage"><Coverage /></PermissionGuard>} />
              <Route path="cotizador" element={<PermissionGuard module="cotizador"><Cotizador /></PermissionGuard>} />
              <Route path="cotizador/:id" element={<PermissionGuard module="cotizador"><Cotizador /></PermissionGuard>} />
              <Route path="presupuestos-sa" element={<PresupuestosSA />} />
              <Route path="presupuestos-sa/:id" element={<PresupuestosSA />} />
              <Route path="pizarra" element={<PizarraSach />} />
              <Route path="biblioteca-simbolos" element={<BibliotecaSimbolos />} />
              <Route path="me" element={<MyProfile />} />
              <Route path="settings" element={<PermissionGuard module="settings"><Settings /></PermissionGuard>} />
              <Route path="admin" element={<PermissionGuard module="admin"><Admin /></PermissionGuard>} />
            </Route>
          </Routes>
        </AuthProvider>
          </BrowserRouter>
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;